import { useState } from "react";
import { DataTypeEnum } from "../../_common/enum/dataType.enum";
import { loadGroupedTicketActionLists } from "../../_helpers/dropdown.helper";
import { dropdownService } from "../../_services/dropdown.service";
import { IGeneric2AutoComplete } from "../../_common/interface/autocomplete/iStandard2Autocomplete";
import StandardMultipleAutoComplete from "./standardMultiple2.autocomplete";

export const DataTypeMultipleAutoComplete = (params: IGeneric2AutoComplete) => {

    const [loadedItems, setLoadedItems] = useState<any[]>([]);

    return (
        <StandardMultipleAutoComplete
            {...params}
            groupBy={params.groupBy ?? (params.dataType === DataTypeEnum.AllTicketActionLists ? "group" : undefined)}
            itemsLoader={() => {
                const loadItems = params.dataType === DataTypeEnum.AllTicketActionLists
                    ? loadGroupedTicketActionLists()
                    : dropdownService.fetchFormDataMultiple(params.dataType, params.parentId);

                return loadItems.then(items => {
                    if (params.onItemsLoaded) {
                        params.onItemsLoaded(items);
                    }
                    setLoadedItems(items);
                    return items;
                });
            }}
        />
    );
}